export default __webpack_public_path__ + "static/media/upload document (1).9eaf4de6.svg";